"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Parser = void 0;
var Scanner_1 = require("./Scanner");
var RowParser_1 = require("./RowParser");
var Token_1 = require("./Token");
var Parser = /*#__PURE__*/function () {
  function Parser(parserOptions) {
    _classCallCheck(this, Parser);
    this.parserOptions = parserOptions;
    this.rowParser = new RowParser_1.RowParser(this.parserOptions);
  }
  _createClass(Parser, [{
    key: "parse",
    value: function parse(line, hasMoreData) {
      var scanner = new Scanner_1.Scanner({
        line: Parser.removeBOM(line),
        parserOptions: this.parserOptions,
        hasMoreData: hasMoreData
      });
      if (this.parserOptions.supportsComments) {
        return this.parseWithComments(scanner);
      }
      return this.parseWithoutComments(scanner);
    }
  }, {
    key: "parseWithoutComments",
    value: function parseWithoutComments(scanner) {
      var rows = [];
      var shouldContinue = true;
      while (shouldContinue) {
        shouldContinue = this.parseRow(scanner, rows);
      }
      return {
        line: scanner.line,
        rows: rows
      };
    }
  }, {
    key: "parseWithComments",
    value: function parseWithComments(scanner) {
      var parserOptions = this.parserOptions;
      var rows = [];
      for (var nextToken = scanner.nextCharacterToken; nextToken !== null; nextToken = scanner.nextCharacterToken) {
        if (Token_1.Token.isTokenComment(nextToken, parserOptions)) {
          var cursor = scanner.advancePastLine();
          if (cursor === null) {
            return {
              line: scanner.lineFromCursor,
              rows: rows
            };
          }
          if (!scanner.hasMoreCharacters) {
            return {
              line: scanner.lineFromCursor,
              rows: rows
            };
          }
          scanner.truncateToCursor();
        } else if (!this.parseRow(scanner, rows)) {
          break;
        }
      }
      return {
        line: scanner.line,
        rows: rows
      };
    }
  }, {
    key: "parseRow",
    value: function parseRow(scanner, rows) {
      var nextToken = scanner.nextNonSpaceToken;
      if (!nextToken) {
        return false;
      }
      var row = this.rowParser.parse(scanner);
      if (row === null) {
        return false;
      }
      if (this.parserOptions.ignoreEmpty && RowParser_1.RowParser.isEmptyRow(row)) {
        return true;
      }
      rows.push(row);
      return true;
    }
  }], [{
    key: "removeBOM",
    value: function removeBOM(line) {
      // Catches EFBBBF (UTF-8 BOM) because the buffer-to-string
      // conversion translates it to FEFF (UTF-16 BOM)
      if (line && line.charCodeAt(0) === 0xfeff) {
        return line.slice(1);
      }
      return line;
    }
  }]);
  return Parser;
}();
exports.Parser = Parser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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